"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Parser = void 0;
var Scanner_1 = require("./Scanner");
var RowParser_1 = require("./RowParser");
var Token_1 = require("./Token");
var Parser = /*#__PURE__*/function () {
  function Parser(parserOptions) {
    _classCallCheck(this, Parser);
    this.parserOptions = parserOptions;
    this.rowParser = new RowParser_1.RowParser(this.parserOptions);
  }
  _createClass(Parser, [{
    key: "parse",
    value: function parse(line, hasMoreData) {
      var scanner = new Scanner_1.Scanner({
        line: Parser.removeBOM(line),
        parserOptions: this.parserOptions,
        hasMoreData: hasMoreData
      });
      if (this.parserOptions.supportsComments) {
        return this.parseWithComments(scanner);
      }
      return this.parseWithoutComments(scanner);
    }
  }, {
    key: "parseWithoutComments",
    value: function parseWithoutComments(scanner) {
      var rows = [];
      var shouldContinue = true;
      while (shouldContinue) {
        shouldContinue = this.parseRow(scanner, rows);
      }
      return {
        line: scanner.line,
        rows: rows
      };
    }
  }, {
    key: "parseWithComments",
    value: function parseWithComments(scanner) {
      var parserOptions = this.parserOptions;
      var rows = [];
      for (var nextToken = scanner.nextCharacterToken; nextToken !== null; nextToken = scanner.nextCharacterToken) {
        if (Token_1.Token.isTokenComment(nextToken, parserOptions)) {
          var cursor = scanner.advancePastLine();
          if (cursor === null) {
            return {
              line: scanner.lineFromCursor,
              rows: rows
            };
          }
          if (!scanner.hasMoreCharacters) {
            return {
              line: scanner.lineFromCursor,
              rows: rows
            };
          }
          scanner.truncateToCursor();
        } else if (!this.parseRow(scanner, rows)) {
          break;
        }
      }
      return {
        line: scanner.line,
        rows: rows
      };
    }
  }, {
    key: "parseRow",
    value: function parseRow(scanner, rows) {
      var nextToken = scanner.nextNonSpaceToken;
      if (!nextToken) {
        return false;
      }
      var row = this.rowParser.parse(scanner);
      if (row === null) {
        return false;
      }
      if (this.parserOptions.ignoreEmpty && RowParser_1.RowParser.isEmptyRow(row)) {
        return true;
      }
      rows.push(row);
      return true;
    }
  }], [{
    key: "removeBOM",
    value: function removeBOM(line) {
      // Catches EFBBBF (UTF-8 BOM) because the buffer-to-string
      // conversion translates it to FEFF (UTF-16 BOM)
      if (line && line.charCodeAt(0) === 0xfeff) {
        return line.slice(1);
      }
      return line;
    }
  }]);
  return Parser;
}();
exports.Parser = Parser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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